<template>
  <div class="flex-grow-1">
    <v-card class="card-pad d-flex align-center mb-4" height="75">
      <v-btn depressed small text color="grey" to="/serviceOrders">
        <v-icon x-small>mdi-arrow-left-bold</v-icon>
        {{ $t('Voltar') }}
      </v-btn>

      <v-spacer></v-spacer>

      <strong>{{ $t('Múltiplas Ordens de Serviço') }}</strong>
    </v-card>

    <v-card class="card-pad pa-2 mt-4">
      <v-form>
        <v-stepper v-model="step" elevation="0">
          <v-stepper-header style="box-shadow: none">
            <v-stepper-step :step="1"> Campos </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :step="2">
              {{ $t('Campos comuns') }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :step="3">
              {{ $t('Campos distintos') }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <SelectFieldsVue @confirm="setSelectedFields" />
            </v-stepper-content>

            <v-stepper-content step="2">
              <CommonFieldsVue
                @confirm="setCommonFields"
                @back="step--"
                :selectedFields="selectedFields"
                :category="category"
                :users="users"
                :equipments="equipments"
                :types="types"
                :unidades="unidades"
              />
            </v-stepper-content>

            <v-stepper-content step="3">
              <DistinctFieldsVue
                @confirm="submit"
                @back="back"
                :selectedFields="selectedFields"
                :category="category"
                :users="users"
                :equipments="equipments"
                :types="types"
                :orders="orders"
                :unidades="unidades"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import CommonFieldsVue from './components/commonFields.vue'
import SelectFieldsVue from './components/selectFields.vue'
import DistinctFieldsVue from './components/distinctFields.vue'

export default {
  name: 'AddMultipleServiceOrder',

  components: {
    CommonFieldsVue,
    SelectFieldsVue,
    DistinctFieldsVue,
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    const user = JSON.parse(localStorage.getItem('user'))

    this.getEquipments()
    this.getUsers()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }
  },

  data() {
    return {
      institution: {},
      users: [],
      orders: [],
      category: null,
      institutionId: '',
      apiService: new ApiService(),
      qtd: 0,
      step: 1,
      selectedFields: [],
      equipments: [],
      types: [
        { text: 'Treinamento', value: 0 },
        { text: 'Segurança elétrica', value: 1 },
        { text: 'Preventiva', value: 2 },
        { text: 'Instalação', value: 3 },
        { text: 'Rotina de Inspeção', value: 4 },
        { text: 'Corretiva', value: 5 },
        { text: 'Calibração', value: 6 },
        { text: 'Validação/Qualificação', value: 7 },
        { text: 'Serviço Administrativo', value: 8 },
        { text: 'Empréstimo', value: 9 },
      ],
      equipLoading: false,
      departLoading: false,
      unidades: [],
    }
  },

  methods: {
    back() {
      if (this.selectedFields.length > 0) {
        this.step--
      } else {
        this.step = this.step - 2
      }
    },

    async getUserUnidades() {
      await this.apiService
        .get(
          `unidade/listByUserAndInstitution/${this.institutionId}`,
          true,
          false
        )
        .then((response) => {
          this.unidades = response.content
        })
    },

    async getUnidades() {
      await this.apiService
        .get(`unidade/list/${this.institutionId}`, true, false)
        .then((response) => {
          this.unidades = response.content
        })
    },

    setSelectedFields(model) {
      this.selectedFields = model.selectedFields
      this.orders = model.orders
      this.category = model.category

      if (this.selectedFields.length > 0) {
        this.step++
      } else {
        this.step = this.step + 2
      }
    },

    setCommonFields(data) {
      this.orders = this.orders.map((x) => {
        return {
          ...x,
          ...data,
        }
      })

      this.step++
    },

    async getEquipments() {
      this.equipLoading = true

      await this.apiService
        .get(`equipment/list/${this.institutionId}`, true, false)
        .then((response) => {
          this.equipments = response.content
          this.equipLoading = false
        })
        .catch((err) => {
          this.equipLoading = false
        })
    },

    async getUsers() {
      await this.apiService
        .get(`user/byType/${this.institutionId}`, true, false)
        .then((response) => {
          this.users = response.content
        })
    },

    submit(result) {
      this.apiService.post('serviceOrder/addmultiple', result).then(() => {
        this.$toast.success(
          this.$t('Ordens de serviço cadastradas com sucesso!')
        )
        this.$router.push('/serviceOrders')
      })
    },
  },
}
</script>
